"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCardDesignOptions = getCardDesignOptions;
function getCardDesignOptions(template, printableGroupType) {
  const interiorDesigns = template.designs.filter(d => !d.allowedPrintableGroupTypes || d.allowedPrintableGroupTypes.includes(printableGroupType));
  return interiorDesigns;
}